<div class="subscription">
  <div class="logo-and-name">
    <img class="logo" src="./assets/images/bird.svg">
    <div class="name">
      <img class="jail" src="./assets/images/jail.svg">
      <img class="house" src="./assets/images/house.svg">
      <img class="mail" src="./assets/images/mail.svg">
    </div>
  </div>

  <div>unsubscribeEmail: {{email}}</div>
  <div>expirationStr: {{expirationStr}}</div>
  <div>signature: {{signature}}</div>
  
  <a (click)="updateEmailSubscription(email, expirationStr, signature, !userIsSubscribed)">{{userIsSubscribed ? "Unsubscribe" : "Resubscribe"}}</a>
</div>